export * from './trackEvent';

declare global {
  interface Window {
    dataLayer: Array<{ event?: string; [key: string]: unknown }>;
  }
}
